const userAgent = navigator.userAgent.toLocaleLowerCase()

export function isOldMiPad() {
    const oldVersion = /model\/mi pad (3|4)/
    return oldVersion.test(userAgent)
}